import { render, staticRenderFns } from "./extra-types.vue?vue&type=template&id=14fc222f"
import script from "./extra-types.vue?vue&type=script&lang=js"
export * from "./extra-types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports